import { render, staticRenderFns } from "./FormularioTransferirExistente.vue?vue&type=template&id=35d0682e"
import script from "./FormularioTransferirExistente.vue?vue&type=script&lang=js"
export * from "./FormularioTransferirExistente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports